// js实现动态变化的数字
const directive = {
  inserted(el, binding) {
    // console.log(el)
    // console.log(binding)
    // 最终要显示的数字
    let finalNum = el.innerText;
    // 动画间隔
    let rate = 30;
    // 总时长
    let time = 2000;
    // 步长,数据增加间隔
    let step = finalNum / (time / rate);
    // 初始值
    let count = 0;
    // 要保留的小数
    let timer = setInterval(() => {
      count = count + step;
      // 根据不同数值显示不同单位
      el.innerText = parseInt(count).toFixed(0) + binding.value.eUnit;
        //   if (count < 1000) {
        //     el.innerText = parseInt(count).toFixed(0) + binding.value.eUnit;
        //   } else {
        //     el.innerText = (count / 1000).toFixed(0) + "千个"
        //   }
      if (count > finalNum) {
        count = finalNum;
        //  避免count大于finalNum最终数字显示不对
        el.innerText = parseInt(count).toFixed(0) + binding.value.eUnit;
        // if (count < 1000) {
        //   el.innerText = parseInt(count).toFixed(0) + "个"
        // } else {
        //   el.innerText = (count / 1000).toFixed(0) + "千个"
        // }
        // 清空定时器
        clearInterval(timer);
        timer = null;
      }
    }, rate);
  },
};
export default directive;
